var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogledrive = function SvgGoogledrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#googledrive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066DA",
    d: "m2.028 20.545 1.184 2.044c.245.43.599.768 1.014 1.014q1.782-2.263 2.482-3.473.71-1.229 1.744-3.842-2.79-.366-4.226-.367-1.38 0-4.226.367c0 .477.123.953.369 1.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M22.604 23.603a2.8 2.8 0 0 0 1.014-1.014l.492-.845 2.351-4.073c.241-.42.368-.897.369-1.383q-2.864-.366-4.218-.367-1.456 0-4.218.367 1.022 2.628 1.72 3.842.705 1.224 2.49 3.473"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832D",
    d: "M13.415 7.683q2.062-2.49 2.843-3.841.628-1.088 1.383-3.473A2.7 2.7 0 0 0 16.258 0h-5.686c-.492 0-.968.138-1.383.369q.96 2.736 1.629 3.894.74 1.28 2.597 3.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FC",
    d: "M18.379 16.289H8.452l-4.226 7.314a2.7 2.7 0 0 0 1.383.369h15.612a2.86 2.86 0 0 0 1.383-.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AC47",
    d: "M13.415 7.683 9.189.37a2.8 2.8 0 0 0-1.014 1.014L.369 14.906A2.8 2.8 0 0 0 0 16.289h8.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA00",
    d: "m22.558 8.144-3.903-6.761A2.8 2.8 0 0 0 17.64.369l-4.226 7.314 4.963 8.605h8.437c0-.476-.123-.952-.37-1.383z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "googledrive_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26.83v24H0z"
  })))));
};
export default SvgGoogledrive;